var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('img',{attrs:{"src":_vm.getAuthorizedSignatureById.auth_sign_url,"height":"50"}}),_c('p',[_vm._v(_vm._s(_vm.getAuthorizedSignatureById.name))]),_c('p',[_vm._v(_vm._s(_vm.getAuthorizedSignatureById.designation))])])
}
var staticRenderFns = []

export { render, staticRenderFns }